module.exports = __webpack_public_path__ + "img/Instagram_black.bfebfc32.svg";